// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"544":"51124589","644":"7b6971d7"}[chunkId] + ".chunk.css");